import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from 'packages';
import { Button } from 'tradera-components/atoms/button/button';
import styles from './tree-item.module.scss';

const ItemContent = ({ uniqueId, name, childrenCount }) => (
    <>
        <div id={uniqueId} className={styles.itemName}>
            {name}
        </div>
        {childrenCount && (
            <div className="align-self-center text-muted size-oslo">
                {formatNumber(childrenCount)}
            </div>
        )}
    </>
);

export const TreeItem = ({ onClick, isNarrow, ...props }) => {
    const { id: itemId, treeId, name, url, isActive, count } = props;
    const uniqueId = `tree-item-${treeId}-${itemId}`;
    const itemClasses = `${
        isNarrow ? 'pb-1' : 'py-1'
    }  d-flex justify-content-between text-inter-medium`;
    const notClickable = !url;

    if (notClickable) {
        return (
            <div
                className={`${itemClasses} ${styles.notClickable} text-muted text-inter-medium`}>
                <ItemContent
                    uniqueId={uniqueId}
                    name={name}
                    childrenCount={count}
                />
            </div>
        );
    }

    return (
        <Button
            link
            unbutton
            href={url}
            useLink={Boolean(url)}
            onClick={
                onClick
                    ? event => {
                          onClick(props, event);
                      }
                    : undefined
            }
            data-test-category-link
            aria-labelledby={uniqueId}
            className={`${styles.treeItem} ${isActive &&
                `${styles.active} font-weight-bold`} ${itemClasses} text-dark`}>
            <ItemContent
                uniqueId={uniqueId}
                name={name}
                childrenCount={count}
            />
        </Button>
    );
};

TreeItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    count: PropTypes.number
};

TreeItem.defaultProps = {
    url: null,
    isActive: false,
    onClick: null,
    count: null
};
